const reportDB = require("../../../../../components/report/report-db");
const style = require('../../../../../components/report/report-style')
const css = style.get()



export function start(detail) {

  const phpFile = 'server/php/sql/report.php'
  detail.inf = { entity: 'clientActivity', report: 'clientActivity-provider-report' }

  reportDB.select(detail, phpFile, (data) => {

    const body = generate(data)
    showReport(body);
  })

}/**/

function showReport(body) {
  let iframe = document.getElementById("reportIframe");
  iframe.src = 'about:blank';

  const doc = iframe.contentWindow.document;

  doc.open();
  doc.write(
    "<!DOCTYPE html><html><head></head><body>" + body + "</body></html>"
  );
  doc.close();
  iframe.contentWindow.print();
  iframe.onload = null;

}



function generate(data) {

  var body = ''
  // body += generateHeader()
  body += generateTop(data)
  body += generateTable(data)
  body += `</div> <!-- dataCont -->`
  body += `<div class="report-page">`

  return body
}

// function generateHeader() {

//   var header = ''
//   header += `<div class="report-page receivable-report dn" id="miDiv5" ${css.table}>`
//   header += `
//                   <div class="report-appbar report-appbar-black" >

//                           <div  data-detail='{"click": [ 
//                                                       {"dest":"ripple" }, 
//                                                       {"dest":"clientActivity", "elem":"dt", "act":"remove" } ] }' >
//                               <svg><use xlink:href="../css/svg.svg#close"></use></svg>
//                           </div>

//                           <h1>All Provider Statement: Accounts Profits All Report</h1>

//                       <div class="fr" data-detail='{"click": [ 
//                                                   {"dest":"ripple" }, 
//                                                   {"dest":"clientActivity", "elem":"dt", "act":"print" }  ] }' >
//                               <svg><use xlink:href="../css/svg.svg#print"></use></svg>
//                               <label>Print</label>
//                       </div>
//                   </div> <!-- appbar -->
//           `

//   header += `
//                   <div class="dataCont receivable-report-dataCont">
//                       <h1  ${css.f32}></h1>
//                       <p   ${css.f14} >
//                                </p>
//           `
//   return header


// }

function generateTop(data) {

  let company_name = "";
  let current_dateTime = "";

  //if no data found
  if (data.length > 0) {
    company_name = data[0].company_name;
    current_dateTime = data[0].current_dateTime;
  } else {
    let config = settings.getData()
    company_name = config.company;
    current_dateTime = timeDate.getdateshort() + ' ' + timeTime.formatAMPM();
  }

  var table = `<br><br><h1 style="text-align: center;">${company_name}</h1>
    <h3 style="text-align: center;">Receivable All Report As Of ${current_dateTime}</h3>
    `;

  return table

}/**/

function generateTable(data) {
  var totals = {
    current_due: 0,
    due_30_days: 0,
    due_31_to_60_days: 0,
    due_61_to_90_days: 0,
    due_over_90_days: 0,
    total_due: 0
  };

  var table = `
      <h2 ${css.f15}>This report consolidates the outstanding amounts owed to you by our company. 
      Use it to track payments you are due from us.</h2>
      <table ${css.table} class="dt-alterColor">
         <tr>
            <th ${css.th}>Code</th>
            <th ${css.th}>Current</th>
            <th ${css.th}>Due ≤ 30 days</th>
            <th ${css.th}>Due 31 to 60 days</th>
            <th ${css.th}>Due 61 to 90 days</th>
            <th ${css.th}>Due Over 90 days</th>
            <th ${css.th}>Total Due</th>
         </tr>
      `;

  // Si no hay datos
  if (data.length == 0) {
    table += `
            <tr>
               <td ${css.td} colspan="8" ><div align="center"><h3>No pending payments found.</h3></div></td>
            </tr>
            </table>`;
    return table;
  }

  for (let i = 0; i < data.length; i++) {
    let row = data[i];

    // Limpieza de valores ($ y comas)
    let current_due = parseFloat(row.current_due.replace(/[$,]/g, '')) || 0;
    let due_30_days = parseFloat(row.due_30_days.replace(/[$,]/g, '')) || 0;
    let due_31_to_60_days = parseFloat(row.due_31_to_60_days.replace(/[$,]/g, '')) || 0;
    let due_61_to_90_days = parseFloat(row.due_61_to_90_days.replace(/[$,]/g, '')) || 0;
    let due_over_90_days = parseFloat(row.due_over_90_days.replace(/[$,]/g, '')) || 0;
    let total_due = parseFloat(row.total_due.replace(/[$,]/g, '')) || 0;

    // Acumuladores
    totals.current_due += current_due;
    totals.due_30_days += due_30_days;
    totals.due_31_to_60_days += due_31_to_60_days;
    totals.due_61_to_90_days += due_61_to_90_days;
    totals.due_over_90_days += due_over_90_days;
    totals.total_due += total_due;

    // Fila
    table += `
            <tr ${rowStyle(i)}>
               <td ${css.td}>${row.code}</td>
               <td ${css.td}>${cashVal(current_due)}</td>
               <td ${css.td}>${cashVal(due_30_days)}</td>
               <td ${css.td}>${cashVal(due_31_to_60_days)}</td>
               <td ${css.td}>${cashVal(due_61_to_90_days)}</td>
               <td ${css.td}>${cashVal(due_over_90_days)}</td>
               <td ${css.td}><b>${cashVal(total_due)}</b></td>
            </tr>`;
  }

  // Totales
  table += `
      <tr ${rowStyle(data.length)}>
         <td ${css.td} style="text-align:right;"><h3>Total</h3></td>
         <td ${css.td}><h4>${cashVal(totals.current_due)}</h4></td>
         <td ${css.td}><h4>${cashVal(totals.due_30_days)}</h4></td>
         <td ${css.td}><h4>${cashVal(totals.due_31_to_60_days)}</h4></td>
         <td ${css.td}><h4>${cashVal(totals.due_61_to_90_days)}</h4></td>
         <td ${css.td}><h4>${cashVal(totals.due_over_90_days)}</h4></td>
         <td ${css.td}><h3>${cashVal(totals.total_due)}</h3></td>
      </tr>
      </table>`;

  return table;
}

function safePercentage(numerator, denominator) {
  if (!denominator || denominator === 0 || isNaN(denominator)) {
    return "0.00"; // Retorna un valor predeterminado si el denominador no es válido
  }

  if (!numerator || isNaN(numerator)) {
    numerator = 0; // Asegura que el numerador no sea `null` o `NaN`
  }

  return parseFloat((numerator / denominator) * 100).toFixed(2);
}

function cashVal(value) {
  return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}

function rowStyle(i) {

  if (i % 2 === 0) { return '' }
  return css.trGray

}